import { useEffect, useState } from "react";
import useFirestore from "../common/useFirestore";
import useAccount from "../authorization/useAccount";

function useUserProgram(){
    const uid = sessionStorage.getItem("uid");
    const {readFirestoreWithQuery, readFirestoreOneDoc} = useFirestore();
    const {getCommonUser} = useAccount(uid);
    const [programList, setProgramList] = useState([]);
    useEffect(() => {
        getUserProgreamList();
    }, [])

    const getUserProgreamList = async() => {
        const user = await getCommonUser();
        const paied_list = await getPaiedProgram(user);
        setProgramList(paied_list);
    }

    const getPaiedProgram = async(user) => {
        const program_list = await readFirestoreWithQuery(`Pay/${user.id}/Order`, {field:"state", operator:"==", data:"PAIED"}).then(res => {
            const list = [];
            if(!res.empty){
                const doc_list = res.docs;
                for(const doc of doc_list){
                    list.push(...doc.data().item);
                }
            }
            list.sort((a, b) => a.paied_date - b.paied_date);
            return list;
        })
        return program_list;
    }


    return {programList};
}

export default useUserProgram;